const scrollBarCssConfig = {
    '&::-webkit-scrollbar': {
        width: '12px'      
    },
    '&::-webkit-scrollbar-track': {
        borderRadius: '8px',
        backgroundColor: 'rgba(255, 255, 255, 0.1)'
    },
    '&::-webkit-scrollbar-thumb': {
        backgroundImage: 'linear-gradient(45deg, #00aeff, #a68eff)',
        borderRadius: '8px',
        boxShadow: 'rgba(0,0,0,.12) 0 3px 8px 1px'
    },
}

export default scrollBarCssConfig
